import { join } from 'node:path';
import { getExtensionDir } from './definitions.js';

export function getSiteWidgetExtensionsDir(projectFolder: string) {
  return join(getExtensionDir(projectFolder), 'site', 'widgets');
}

export function getSiteWidgetExtensionPath(
  projectFolder: string,
  extensionPath: string
) {
  return join(getSiteWidgetExtensionsDir(projectFolder), extensionPath);
}

export function getSitePluginExtensionsDir(projectFolder: string) {
  return join(getExtensionDir(projectFolder), 'site', 'plugins');
}

export function getSitePluginExtensionPath(
  projectFolder: string,
  extensionPath: string
) {
  return join(getSitePluginExtensionsDir(projectFolder), extensionPath);
}

export function getEmbeddedScriptExtensionsDir(projectFolder: string) {
  return join(getExtensionDir(projectFolder), 'site', 'embedded-scripts');
}

export function getEmbeddedScriptExtensionPath(
  projectFolder: string,
  extensionPath: string
) {
  return join(getEmbeddedScriptExtensionsDir(projectFolder), extensionPath);
}
